// Pure GeoJSON/expression builders for the route map.
//
// Split from mapTripReport.js so they can be tested without importing react-map-gl and the
// component tree behind it — the same reason the O/D panel keeps odAnalyticsUtils.js separate
// from its views.

import { UNKNOWN_COLOR } from './mapColors';

export const EMPTY_FC = { type: 'FeatureCollection', features: [] };

export const tripsToFeatureCollection = (trips) => ({
    type: 'FeatureCollection',
    features: (trips || [])
        .filter((trip) => trip?.tripGeo)
        .map((trip, index) => ({
            type: 'Feature',
            id: index,
            properties: { id: trip.startTraceId, n: index + 1 },
            geometry: trip.tripGeo,
        })),
});

/**
 * Point features from analytics rows that carry a fix.
 *
 * Rows without one are dropped rather than plotted at [0, 0] — an event in the Gulf of Guinea is
 * worse than an event that only exists in the table. `properties` stays flat and stringified
 * because Mapbox `match` expressions compare against literals.
 */
export const pointsToFeatureCollection = (rows, toProperties) => ({
    type: 'FeatureCollection',
    features: (rows || [])
        .filter((row) => Number.isFinite(row?.lat) && Number.isFinite(row?.lon))
        .map((row, index) => ({
            type: 'Feature',
            id: index,
            properties: toProperties(row),
            geometry: { type: 'Point', coordinates: [row.lon, row.lat] },
        })),
});

/**
 * ['match', ['get', key], value, colour, …, fallback] from a plain object.
 *
 * The fallback is a deliberate grey rather than another category's colour: an enum value the
 * client has not been taught should look unknown, not look like a harsh brake.
 */
export const matchColor = (key, colors) => [
    'match',
    ['get', key],
    ...Object.entries(colors).flat(),
    UNKNOWN_COLOR,
];
